import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router';
import { API_URL } from '../../../config/constants';
import arrowIconImg from '../../../images/filledArrowIcon.png';
import FadeOutNoti from '../../components/FadeOutNoti';
import moment from 'moment';
import 'moment/locale/ko';
import Select from 'react-select';
import { CustomDatePicker } from '../../components/CustomDatePicker';
import { useSelector } from 'react-redux';
import Loading from '../../components/Loading';
import useAsync from '../../../hooks/useAsync';
import { useLocation, useSearchParams } from 'react-router-dom';
import DetailDataTRs from './components/DetailDataTRs';

function DataDetail(props) {

    const { modelTypeArr, dataArr, setDataArr } = useOutletContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const sumDsId = searchParams.get("sumDsId");
    const dataId = searchParams.get("dataId");
    const navigate = useNavigate();
    const location = useLocation();
    const { userRank, privilege } = useSelector((state) => state.session);

    const [formData, setFormData] = useState({
        time: "2000-01-01T00:00:00.000Z",
        count: 0,
        decision: 'OK',
        modelId: 0,
        model: {
            modelType: '',
            modelName: '',
            modelNo: '',
        },

        ngFactor: '',
        comment: '',
    });
    const [realData, setRealData] = useState({
        time: "2000-01-01T00:00:00.000Z",
        count: 0,
        decision: 'OK',
        modelId: 0,
        model: {
            modelType: '',
            modelName: '',
            modelNo: '',
        },

        ngFactor: '',
        comment: '',
    });
    const [dateTime, setDateTime] = useState(new Date());
    const [modelTypes, setModelTypes] = useState([]);
    const [modelNames, setModelNames] = useState([]);
    const [modelNos, setModelNos] = useState([]);
    const [sumDs, setSumDs] = useState({});
    const [showNoti, setShowNoti] = useState(false);



    function onSubmit(e) {
        e.preventDefault();
        const { dataId, ...rest } = formData;
        if (formData.modelId === 0) return false;

        axios.post(`${API_URL}/android/updateData`, {
            sumDsId,
            dataId: dataId, newValue: {
                ...rest,
                time: moment(dateTime),
            }
        }).then(res => {
            const copiedArr = [...dataArr];
            const filteredArr = copiedArr.filter(item => item.dataId !== dataId);
            setDataArr([...filteredArr, res.data]);
            const normalizedData = { ...res.data, comment: res.data.comment ?? '', ngFactor: res.data.ngFactor ?? '' };
            setFormData(normalizedData);
            setRealData(normalizedData);
            setDateTime(new Date(normalizedData.time));
            setShowNoti(true);
        });
    };

    async function onChange(e) {
        e.preventDefault();
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    async function modelInit(modelId) {
        setModelTypes([...modelTypeArr.map(item => ({ label: item, value: item }))]);
        await axios.post(`${API_URL}/android/getModelById`, { modelId }).then(res => {
            const { modelNames, modelNos } = res.data;
            setModelNames([...modelNames.map(item => ({ label: item, value: item }))]);
            setModelNos([...modelNos.map(item => ({ label: item.modelNo, value: item }))]);
        }).catch(e => console.error(e));
    }
    const decisionOpt = [
        { label: 'NG', value: 'NG' },
        { label: 'OK', value: 'OK' },
    ];

    const ngFactorOpt = [
        { label: '없음', value: '' },
        { label: '원자재 - YS', value: '원자재 - YS' },
        { label: '원자재 - UTS', value: '원자재 - UTS' },
        { label: '하중 - Peak', value: '하중 - Peak' },
        { label: '하중 - 이상패턴', value: '하중 - 이상패턴' },
        { label: '치수 - 좌', value: '치수 - 좌' },
        { label: '치수 - 우', value: '치수 - 우' },
    ]

    async function getOneData() {
        await axios.post(`${API_URL}/monitoring-manage/getSumData`, { sumDsId, dataId }).then(res => {
            const resSuccess = res.data.success;
            const resData = res.data.data
            console.log(resData);
            if (resSuccess) {
                setSumDs({ ...res.data.sumDs });
                modelInit(resData.modelId);
                const normalizedData = { ...resData, comment: resData.comment ?? '', ngFactor: resData.ngFactor ?? '' };
                setFormData(normalizedData);
                setRealData(normalizedData)
                setDateTime(new Date(resData.time));
            } else {
                navigate('/home/data/sumData');
            }
        }).catch(err => console.error(err));
    }


    useEffect(() => {
        // if (data) {
        //     modelInit(data.modelId);
        //     setFormData({ ...data });
        //     setDateTime(new Date(data.time))
        // } else {
        //     navigate('/home/data/sumData');
        // }
        getOneData();
    }, []);

    const changed =
        Object.keys(sumDs).length > 0 &&
        (
            JSON.stringify(formData) !== JSON.stringify(realData) ||
            moment(dateTime).valueOf() !== moment(realData.time).valueOf()
        );

    function onReset(e) {
        e.preventDefault();
        setFormData({ ...realData, model: { ...realData.model } });
        setDateTime(new Date(realData.time));
    }

    function onBack(e) {
        e.preventDefault();
        navigate(location.state?.returnTo || -1);
    }

    return (
        <React.Fragment>
            <div className='dataEditArea'>
                <p className='path'>데이터 관리<span className='below'>{'>'}</span>공정 요약<span className='below'>{'>'}</span>데이터 상세</p>
                <h2 className='pageTitle'>데이터 상세</h2>
                <div className='pageContent'>
                    <form onSubmit={onSubmit} >
                        <table>
                            <tbody>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor="time">시간</label></td>
                                    <td className='inputTd' >
                                        {privilege.sumData.update ? moment(dateTime).format('YYYY-MM-DD HH:mm:ss') :
                                            <CustomDatePicker
                                                data={dateTime} setData={setDateTime}
                                            />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor="count">카운트</label></td>
                                    <td className='inputTd' >
                                        <input id="count" name="count" type="number" value={formData.count} onChange={onChange} readOnly={privilege.sumData.update} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor='decision'>판정</label></td>
                                    <td className='inputTd' >
                                        {
                                            privilege.sumData.update
                                                ? `${decisionOpt.find(el => el.value === formData.decision).value}`
                                                : <div className='selectArea'>
                                                    <Select
                                                        options={decisionOpt}
                                                        value={decisionOpt.find(el => el.value === formData.decision)}
                                                        onChange={sel => setFormData({ ...formData, decision: sel.value })}
                                                        isSearchable={false}
                                                        classNames={{
                                                            control: (state) => 'control',
                                                            container: (state) => 'selectBox',
                                                            dropdownIndicator: (state) => 'arrow',
                                                            menu: (state) => 'options',
                                                            option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                            singleValue: (state) => 'singleVal',
                                                            valueContainer: (state) => 'valueContainer',
                                                        }}
                                                        components={{
                                                            DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                            IndicatorSeparator: (state) => null,
                                                        }}
                                                    />

                                                </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor='modelType'>차종</label></td>
                                    <td className='inputTd' >
                                        {
                                            privilege.sumData.update
                                                ? `${modelTypes.find(el => el.value === formData.model.modelType)?.value}`
                                                :
                                                <div className='selectArea'>
                                                    <Select
                                                        options={modelTypes}
                                                        value={modelTypes.find(el => el.value === formData.model.modelType)}
                                                        onChange={async sel => {
                                                            await axios.post(`${API_URL}/android/getModelNames`, { modelType: sel.value }).then(res => {
                                                                setModelNames([...res.data.map(item => ({ label: item, value: item }))]);
                                                                // modelNamesDropdown.current.value = "";
                                                                setModelNos([]);
                                                                // modelNosDropdown.current.value = "";
                                                                setFormData({
                                                                    ...formData,
                                                                    modelId: 0,
                                                                    model: {
                                                                        modelType: sel.value,
                                                                        modelName: '',
                                                                        modelNo: '',
                                                                    }
                                                                });
                                                            }).catch(err => console.error(err));
                                                        }}
                                                        isSearchable={false}
                                                        classNames={{
                                                            control: (state) => 'control large',
                                                            container: (state) => 'selectBox',
                                                            dropdownIndicator: (state) => 'arrow',
                                                            menu: (state) => 'options',
                                                            option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                            singleValue: (state) => 'singleVal',
                                                            valueContainer: (state) => 'valueContainer',
                                                        }}
                                                        components={{
                                                            DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                            IndicatorSeparator: (state) => null,
                                                        }}
                                                    />
                                                </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor='modelName'>품명</label></td>
                                    <td className='inputTd' >
                                        {
                                            privilege.sumData.update
                                                ? `${modelNames.find(el => el.value === formData.model.modelName)?.value}`
                                                :
                                                <div className='selectArea'>

                                                    <Select
                                                        options={modelNames}
                                                        value={formData.model.modelName === "" ? { label: '선택' } : modelNames.find(el => el.value === formData.model.modelName)}
                                                        onChange={async sel => {
                                                            await axios.post(`${API_URL}/android/getModelNos`, { modelType: formData.model.modelType, modelName: sel.value }).then(res => {
                                                                setModelNos([...res.data.map(item => ({ label: item.modelNo, value: item }))]);
                                                                // modelNosDropdown.current.value = "";
                                                                setFormData({
                                                                    ...formData,
                                                                    modelId: 0,
                                                                    model: {
                                                                        ...formData.model,
                                                                        modelName: sel.value,
                                                                        modelNo: '',
                                                                    }
                                                                });
                                                            }).catch(err => console.error(err));
                                                        }}
                                                        isSearchable={false}
                                                        isDisabled={modelNames.length === 0}
                                                        classNames={{
                                                            control: (state) => 'control large',
                                                            container: (state) => 'selectBox',
                                                            dropdownIndicator: (state) => 'arrow',
                                                            menu: (state) => 'options',
                                                            option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                            singleValue: (state) => 'singleVal',
                                                            valueContainer: (state) => 'valueContainer',
                                                        }}
                                                        components={{
                                                            DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                            IndicatorSeparator: (state) => null,
                                                        }}
                                                    />
                                                </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor='modelNo'>품번</label></td>
                                    <td className='inputTd' >
                                        {
                                            privilege.sumData.update
                                                ? `${modelNos.find(el => el.value.modelNo === formData.model.modelNo)?.value.modelNo}`
                                                :
                                                <div className='selectArea'>
                                                    <Select
                                                        options={modelNos}
                                                        value={formData.model.modelNo === "" ? { label: '선택' } : modelNos.find(el => el.value.modelNo === formData.model.modelNo)}
                                                        onChange={sel => {
                                                            setFormData({
                                                                ...formData,
                                                                modelId: sel.value.modelId,
                                                                model: {
                                                                    ...formData.model,
                                                                    modelNo: sel.value.modelNo,
                                                                }
                                                            })
                                                        }}
                                                        isSearchable={false}
                                                        isDisabled={modelNos.length === 0}
                                                        classNames={{
                                                            control: (state) => 'control large',
                                                            container: (state) => 'selectBox',
                                                            dropdownIndicator: (state) => 'arrow',
                                                            menu: (state) => 'options',
                                                            option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                            singleValue: (state) => 'singleVal',
                                                            valueContainer: (state) => 'valueContainer',
                                                        }}
                                                        components={{
                                                            DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                            IndicatorSeparator: (state) => null,
                                                        }}
                                                    />
                                                </div>
                                        }
                                    </td>
                                </tr>
                                <DetailDataTRs
                                    sumDs={sumDs}
                                    data={realData}
                                    isNormalUser={privilege.sumData.update}
                                    onChange={onChange}
                                    onChangeBool={(name, sel) => setFormData({ ...formData, [name]: sel.value })}
                                    formData={formData}
                                />

                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor='ngFactor'>NG 요인</label></td>
                                    <td className='inputTd' >
                                        {
                                            privilege.sumData.update
                                                ? `${ngFactorOpt.find(el => el.value === formData.ngFactor).value === '' ? '없음' : ngFactorOpt.find(el => el.value === formData.ngFactor).value}`
                                                :
                                                <div className='selectArea'>
                                                    <Select
                                                        options={ngFactorOpt}
                                                        value={ngFactorOpt.find(el => el.value === formData.ngFactor)}
                                                        onChange={sel => setFormData({ ...formData, ngFactor: sel.value })}
                                                        isSearchable={false}
                                                        maxMenuHeight={'140px'}
                                                        classNames={{
                                                            control: (state) => 'control',
                                                            container: (state) => 'selectBox',
                                                            dropdownIndicator: (state) => 'arrow',
                                                            menu: (state) => 'options',
                                                            option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                            singleValue: (state) => 'singleVal',
                                                            valueContainer: (state) => 'valueContainer',
                                                        }}
                                                        components={{
                                                            DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                            IndicatorSeparator: (state) => null,
                                                        }}
                                                    />
                                                </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className='labelTd' colSpan={2}><label htmlFor='comment'>코멘트</label></td>
                                    <td className='inputTd' >
                                        <div className='commentArea'>
                                            <textarea id='comment' name='comment' value={formData.comment} onChange={onChange} readOnly={privilege.sumData.update} />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className='formBtnArea'>
                            {
                                privilege.sumData.update
                                    ?
                                    <button className='backBtn' onClick={onBack}>돌아가기</button>
                                    :
                                    <React.Fragment>
                                        <input className='submitBtn' type='submit' value="수정" disabled={!changed} />
                                        <button type='button' className='cancelBtn' onClick={onReset} disabled={!changed}>취소</button>
                                        <button type='button' className='backBtn' onClick={onBack}>돌아가기</button>
                                    </React.Fragment>
                            }
                        </div>
                    </form>
                </div>
            </div>
            <FadeOutNoti
                showNoti={showNoti}
                onClose={() => {
                    setShowNoti(false);
                }}
                msg={"변경 사항이 저장되었습니다."}
                bg={true}
            />
        </React.Fragment>
    );
}

export default DataDetail;
